export default "__VITE_ASSET__DydepT86__"